export enum SocialIDType {
    PESEL = 0,
    Passport = 1,
    "Paszport Polsatu" = 2,
}